import React, {useState} from 'react';
import styles from './HelpSectionDropdown.module.scss';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import {SERVICES} from '.';
import MuiIcon from 'components/Icons/MuiIcon';
import {keys, lowerCase, startCase} from 'lodash';

function HelpSectionDropdown({onSelect, selected}) {
  const selectedItem = SERVICES[selected];
  const {title, icon, color} = selectedItem;

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={styles['dropdown']}>
      <Dropdown isOpen={isOpen} toggle={toggle} className="w-100">
        <DropdownToggle className={styles[`dropdown--toggle-${color}`]}>
          <div className="d-flex flex-grow-1 align-items-center">
            <MuiIcon name={icon} className="mr-2" />
            {title}
          </div>
          <MuiIcon name={isOpen ? 'expand_less' : 'expand_more'} size="lg" />
        </DropdownToggle>
        <DropdownMenu className="w-100">
          {keys(SERVICES).map((key) => {
            const {title, color} = SERVICES[key];

            return (
              <DropdownItem
                key={key}
                className={styles[`dropdown--item-${color}`]}
                onClick={() => onSelect(key)}
              >
                {startCase(lowerCase(title))}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default HelpSectionDropdown;
